<template>
  <RfButtonNew
    type="none"
    class="border-beige-10 [&:not(.disabled)]:hover:border-beige-40 [&:not(.disabled)]:hover:bg-beige-0 [&:not(.disabled)]:active:bg-beige-5 focus-within:border-beige-40 focus-within:bg-beige-5 [&:not(.disabled)]:focus-visible:outline-beige-90 flex-col rounded-lg border border-solid p-4! *:w-full [&_.rf-button--container]:self-start [&:not(.disabled)]:focus-visible:outline-2 [&:not(.disabled)]:focus-visible:outline-offset-2 [&:not(.disabled)]:active:border-blue-50"
  >
    <div class="flex w-full grow flex-col items-start gap-2 self-stretch">
      <span v-if="$slots.image || image" class="inline-flex aspect-3/2 h-auto w-full p-0">
        <slot v-if="$slots.image" name="image" />
        <img
          v-else
          alt=""
          :src="image"
          class="h-full w-full object-contain"
          style="background-color: #333333"
        />
      </span>
      <span class="flex flex-col items-start gap-1 text-start">
        <span class="text-buttons">{{ props.title }}</span>
        <span v-if="props.description" class="text-beige-50 text-xs">{{ props.description }}</span>
      </span>
      <template v-if="tags.length">
        <RfColorTag
          v-for="tag in tags"
          :key="tag"
          :title="tag.label"
          pill
          disabled
          class="mt-auto mb-0"
          :backgroundColor="getCategoryColor(tag.value)"
        />
      </template>
    </div>
  </RfButtonNew>
</template>

<script setup>
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfColorTag from "@/components/tags/RfColorTag.vue";
import { getCategoryColor } from "@/utils/constants/EngagementCategoryConstants";
const props = defineProps({
  image: { type: String, default: "" },
  title: { type: String, default: "" },
  description: { type: String, default: "" },
  tags: { type: Array, default: () => [] },
});
</script>
